/**
 * Layout Preferences Utility
 * Manages layout (list/grid) and density (normal/compact) only.
 * Theme is handled separately by ThemeContext.
 *
 * Backward compatible with old localStorage key:
 *   'hisab_dashboard_layout' → 'comfortable' | 'compact'
 */

const LEGACY_KEY = 'hisab_dashboard_layout';
const PREFS_KEY = 'hisab_view_prefs';

const LAYOUT_ALIAS = { comfortable: 'list', compact: 'grid' };
const LAYOUT_REVERSE = { list: 'comfortable', grid: 'compact' };

const DEFAULTS = {
  layout: 'list',
  density: 'normal',
  _manual: false,
};

/**
 * Load prefs — migrate from legacy key if needed.
 */
export function loadPrefs() {
  try {
    const raw = localStorage.getItem(PREFS_KEY);
    if (raw) {
      const parsed = JSON.parse(raw);
      return { ...DEFAULTS, layout: parsed.layout || DEFAULTS.layout, density: parsed.density || DEFAULTS.density, _manual: parsed._manual || false };
    }

    const legacy = localStorage.getItem(LEGACY_KEY);
    if (legacy) {
      const layout = LAYOUT_ALIAS[legacy] || legacy;
      const prefs = { ...DEFAULTS, layout, density: layout === 'grid' ? 'compact' : 'normal', _manual: true };
      localStorage.setItem(PREFS_KEY, JSON.stringify(prefs));
      localStorage.removeItem(LEGACY_KEY);
      return prefs;
    }
  } catch { /* ignore corrupt data */ }
  return { ...DEFAULTS };
}

/**
 * Save layout prefs.
 */
export function savePrefs(partial) {
  const current = loadPrefs();
  const next = { ...current, ...partial, _manual: true };
  localStorage.setItem(PREFS_KEY, JSON.stringify(next));
  localStorage.setItem(LEGACY_KEY, LAYOUT_REVERSE[next.layout] || next.layout);
  return next;
}

/**
 * Detect sensible default layout based on viewport.
 */
export function autoLayout() {
  if (typeof window === 'undefined') return 'list';
  return window.innerWidth < 480 ? 'grid' : 'list';
}
